var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:#B1E5FD;}\r\n\t.st4{fill:#7FD5FB;}\r\n\t.st5{fill:#D0BFEA;}\r\n\t.st6{fill:#A586D7;}\r\n\t.st7{fill:#AEECB9;}\r\n\t.st8{fill:#85E295;}\r\n\t.st9{fill:#214575;}\r\n\t.st10{fill:none;}\r\n\t.st11{fill:#0D253D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "858.49,178.27 756.93,191.95 756.93,878.42 496.01,878.42 496.01,986.77 959,924.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "426.24,878.42 441.82,994.07 496.01,986.77 496.01,878.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "634.74,125.56 641.62,62.68 496.01,46.75 496.01,125.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "496.01,125.56 496.01,46.75 122.86,5.93 41,754.34 235.08,775.57 235.08,125.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "235.08,125.56 235.08,775.57 235.08,878.42 426.24,878.42 496.01,878.42 496.01,804.11 496.01,227.1  496.01,125.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "634.74,125.56 496.01,125.56 496.01,227.1 496.01,804.11 496.01,878.42 756.93,878.42 756.93,191.95  756.93,125.56  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.53,
    y: 578.65,
    className: "st9",
    width: 360.96,
    height: 47.44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.24,
    y: 675.83,
    className: "st9",
    width: 261.25,
    height: 47.44
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M551.99,339.02c16.93,0,30.7-13.77,30.7-30.7c0-16.93-13.77-30.7-30.7-30.7h-55.98v61.41h22.66H551.99z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.55,
    y: 220.03,
    className: "st9",
    width: 57.58,
    height: 293.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M464.44,339.02c-8.22,0-12.68,9.62-7.37,15.89l38.93,46v-61.89H464.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M654.58,498.25l-87.82-102.89l-48.09-56.34h-22.66v61.89l95.09,112.33h56.57 C655.42,513.24,659.61,504.15,654.58,498.25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.83,
    y: 220.03,
    className: "st9",
    width: 41.18,
    height: 57.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M582.69,308.31c0,16.93-13.77,30.7-30.7,30.7h-33.32l48.09,56.34c41.68-7.05,73.51-43.4,73.51-87.05 c0-48.68-39.6-88.28-88.28-88.28h-55.98v57.58h55.98C568.92,277.61,582.69,291.38,582.69,308.31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.09d9663d67e52d1f05d905e83145b6c4.svg";
export { ForwardRef as ReactComponent };